import '@fontsource/montserrat';
import '@fontsource/montserrat/400-italic.css'
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/700-italic.css';
import '@fontsource/montserrat/900.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Main from './components/Main';
import AppContextProvider from './contexts/AppContext';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat',
  },
});

function App() {
  return (
    <>
      <AppContextProvider>
        <ThemeProvider theme={theme}>
          <Main />
        </ThemeProvider>
      </AppContextProvider>
      <div style={{ display: 'none' }}>
        Adrienne Wilkinson
        film testing
        film festival
        indie film
        test screening
        film doctor
        studio
        pitch review
        celebrity approval
        endorsement
        fix my film
        film feedback
        help for filmmakers
        help for content creators
        creative consulting
        Plan A
        Plan A consulting
        Adrienne Wilkinson consulting
        Adrienne Wilkinson creative consultant
        Adrienne Wilkinson Consulting Producer
        creative coaching
        script analysis
        entertainment
        pilots
        analysation
        celebrity
        awards
        Actress
        Producer
        Consultant
        Voice artist
        Script consultant
        Script notes
        Film consultant
        Script doctor
        Film notes
        content creator
        talent whisperer
        creative bootcamp
        filmmaker bootcamp
        secret weapon
        animation
        video games
        screenwriting
        writer bootcamp
        staged readings
        virtual script readings
        professional actor
        project feedback
        creative retreat
        writers retreat
        online film school
        Actor
        pitch
        direction
        film solutions
        EDL
        assistance
        guidance
        hone your craft
        entertainment industry
        award winning content
        Television
        television series
        television pilot
        webseries
        online series
        online content
        professional content creator
        Film
        Voice over
        bring my dream to reality
        make my dream a reality
        how to navigate Hollywood
        how to navigate lalaland
        how to be successful in the movie business
        how to be successful in hollywood
        how to be successful in the film business
        how to be successful in the film industry
        how A-list movies became successful
        How my independent film can be successful
        how my independent film can make money
        How to sell my film
        How can my film win awards
        how can I work with professional filmmakers
        how can I work with industry professionals
        how to take my talent to the next level
        how to take my work to the next level
        how to take my writing to the next level
        how to take my film to the next level
        Independent film
        Indie film
        Studio
        Film Project
        Script help
        Pre production
        Film guru
        Script guru
        professional filmmakers
        media creators
        master class
        quality control
        modern media
        Make my film better
        how to pitch to a studio
        how to write for film
        how to write for television
        how to sell my pilot
        how to pitch to an investor
        media coaching
        affordable film testing
        edit screening
        covert assistance
        from script to screen
        launching a film
        launching my writing career
        studio approved
        proven results
        great help for my movie
        make my movie better
        solutions for post production
        the best media consultant
        best media consulting
        most effective media consultant
        best media consulting
        best film consultant
        most effective film consultant
        affordable film consulting
        consulting producer
        professional film consulting
        professional film consultant
        professional media consulting
        professional media consultant
        proven media consulting
        proven media consultant
        real results for improving my film
        How to solve creative problems
        How to solve issues with my creative team
        How can I make my film project work
        How can I make my film better
        How do I connect with film professionals
        How do I present my project to an investor
        Tips for pitching my project
        best advice on how to pitch my project
        film mentorship
        creative mentor
        entertainment industry career mentor
        how to find someone to help amplify my talent
        one on one mentorship for my project
        one on one mentorship for my film
        modern media thought leader
        best writers retreat
        how to gain creative momentum
        where to find creative motivation
        accountability partner
        Is my movie working?
        How do I know if my movie is working
        How do I know if my edit is working
        How do I know if an audience will like my film
        Does my film make sense
        how to define my creative idea
        industry experts
        advice from entertainment industry experts
        help from entertainment industry experts
        Media miracle worker
        affordable film test screening
        how to add clarity to my film
        Affordable film testing
        real  industry feedback for my project
        I'm in creative crisis
        My film isn't working
        suggestions to get my film back on track
        How to help get me out of creative crisis
        Who can help me sort a creative crisis
        how to get the entertainment industry interested in me
        how to get the entertainment industry interested in my work
        professional industry mentorship
        I need a champion for my project
        How do I get real actors to read my script
        Coaching
        advice
        award nominated
        make your work better
        industry experts
        streaming
        script
        writing
        testing
        quality control
        editing
        pitch/es
        review
        proofing
        feedback,
        specialist
        mentor
      </div>
    </>
  );
}

export default App;
